import React from 'react';
import loadScript from 'load-script';
import styles from './NextivaSurveyAlreadyTakenMessage.scss';

class NextivaSurveyAlreadyTakenMessage extends React.Component {
  componentDidMount() {
    loadScript('//fast.wistia.com/embed/medias/gfuphy3pj4.jsonp');
    loadScript('//fast.wistia.com/assets/external/E-v1.js');
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.control}>
            <div className={styles.headerLogo}>
              <img
                src="https://www.nextiva.com/images/Nextiva-Logo.svg"
                alt="Nextiva Logo"
                width="150"
                height="95"
              />
            </div>
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.control}>
            <div className={styles.bodyLeft}>
              <h1>You're done!</h1>
              <p>
                It looks like this survey has already been processed. If you
                have any further questions or comments, please feel free to
                contact us at 800-285-7995 or{' '}
                <a href="mailto:support@nextiva.com">support@nextiva.com</a>.
              </p>
              <p>
                For more resources about Nextiva's products and services, please
                visit our{' '}
                <a href="https://www.nextiva.com/support/">
                  Online Support Center
                </a>{' '}
                and our{' '}
                <a href="https://www.nextiva.com/resources/guides.html">
                  Guides & Video Tutorials page
                </a>.
              </p>
            </div>
            <div className={styles.bodyRight}>
              <div className={styles.video}>
                <div
                  className="wistia_responsive_padding"
                  style={{ padding: '56.0% 0 0 0', position: 'relative' }}
                >
                  <div
                    className="wistia_responsive_wrapper"
                    style={{
                      height: '100%',
                      left: 0,
                      position: 'absolute',
                      top: 0,
                      width: '100%',
                    }}
                  >
                    <span
                      // eslint-disable-next-line max-len
                      className="wistia_embed wistia_async_gfuphy3pj4 popover=true popoverAnimateThumbnail=true videoFoam=true"
                      style={{
                        display: 'inline-block',
                        height: '100%',
                        width: '100%',
                      }}
                    >
                      &nbsp;
                    </span>
                  </div>
                </div>
                <div className={styles.videoText}>
                  We strive to always provide you with Amazing Service What does
                  this mean for you? Our team explains.
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className={styles.separator} />
        <div className={styles.featuredIn}>
          <div className={styles.control}>
            <h3 className={styles.featuredInTitle}>
              NEXTIVA HAS BEEN FEATURED IN
            </h3>
            <div className={styles.publishers}>
              <img
                src="https://www.nextiva.com/images/company/news-and-media/bloomberg-logo.jpg"
                alt="Bloomberg Businessweek"
              />
              <img
                src="https://www.nextiva.com/images/company/news-and-media/forbes-logo.jpg"
                alt="Forbes"
              />
              <img
                src="https://www.nextiva.com/images/company/news-and-media/cio-logo.jpg"
                alt="CIO"
              />
              <img
                src="https://www.nextiva.com/images/company/news-and-media/business-insider-logo.png"
                alt="Business Insider"
              />
              <img
                src="https://www.nextiva.com/images/company/news-and-media/fast-company-logo.png"
                alt="Fast Company"
              />
              <img
                src="https://www.nextiva.com/images/company/news-and-media/entrepreneur-logo.jpg"
                alt="Entrepreneur"
              />
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.control}>
            <p className={styles.footerTitle}>
              Nextiva is the leader in Business VoIP Services. Copyright
              Nextiva, All Rights Reserved.
            </p>
            <div className={styles.socialIcons}>
              <a href="https://www.facebook.com/NEXTIVA/" target="_blank">
                <img
                  src="https://www.nextiva.com/images/social-icons/facebook-circle.jpg"
                  alt="Facebook"
                />
              </a>
              <a href="https://twitter.com/nextiva" target="_blank">
                <img
                  src="https://www.nextiva.com/images/social-icons/twitter-circle.jpg"
                  alt="Twitter"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/nextiva"
                target="_blank"
              >
                <img
                  src="https://www.nextiva.com/images/social-icons/linkedin-circle.jpg"
                  alt="LinkedIn"
                />
              </a>
              <a
                href="https://www.youtube.com/subscription_center?add_user=nextiva"
                target="_blank"
              >
                <img
                  src="https://www.nextiva.com/images/social-icons/youtube-circle.jpg"
                  alt="YouTube"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NextivaSurveyAlreadyTakenMessage;
